import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import FouContainer from 'src/components/tools/fou-container/'
import Misc from 'src/utils/helper/misc'

export default {
  name: 'rejection-history',
  data: function () {
    return {
      messageSectionVisible: false,
      expandButtonText: 'Expand'
    }
  },
  components: {
    FouContainer,
    ...FouGrid,
    FouGroup
  },
  props: {
    rejectionHistory: {
      type: Array,
      default: []
    }
  },
  methods: {
    ...Misc,
    setMessageSectionVisible () {
      if (this.messageSectionVisible) {
        this.messageSectionVisible = false
        this.expandButtonText = 'Expand'
      } else {
        this.messageSectionVisible = true
        this.expandButtonText = 'Collapse'
      }
    }
  }
}
